/* ==========================================================================
   HOME PASSION · kendi yumusak kaydirmamiz
   Native scroll-behavior:smooth bazi tarayici/ayar kombinasyonlarinda
   sessizce calismiyor (ok tuslari olu kaliyordu). Bu yuzden kaydirmayi
   kendimiz animasyonluyoruz: rAF varsa rAF, yoksa setTimeout.
   ========================================================================== */
(function(){
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window)
          : function(f){ return setTimeout(function(){ f(Date.now()); }, 16); };
  var caf = window.cancelAnimationFrame ? window.cancelAnimationFrame.bind(window)
          : clearTimeout;

  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

  /* el: kaydirilacak eleman, to: hedef px, ms: sure */
  window.hpScrollTo = function(el, to, ms){
    if(!el) return;
    var max = el.scrollWidth - el.clientWidth;
    to = Math.max(0, Math.min(max, to));
    if(el.__hpAnim){ caf(el.__hpAnim); el.__hpAnim = null; }
    var from = el.scrollLeft;
    var dist = to - from;
    if(Math.abs(dist) < 1) return;
    if(RM || !ms){ el.scrollLeft = to; return; }

    var t0 = null;
    function step(now){
      if(t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / ms);
      el.scrollLeft = from + dist * easeOutCubic(p);
      if(p < 1){ el.__hpAnim = raf(step); }
      else { el.__hpAnim = null; el.scrollLeft = to; }
    }
    el.__hpAnim = raf(step);

    /* emniyet: rAF kisilirsa 600ms sonra dogrudan otur */
    setTimeout(function(){
      if(el.__hpAnim && Math.abs(el.scrollLeft - to) > 2){
        caf(el.__hpAnim); el.__hpAnim = null; el.scrollLeft = to;
      }
    }, (ms || 420) + 260);
  };

  window.hpScrollBy = function(el, dx, ms){
    window.hpScrollTo(el, el.scrollLeft + dx, ms);
  };

  /* Bir karuselde kart genisligi + bosluk */
  window.hpStep = function(el){
    var c = el.firstElementChild;
    if(!c) return 400;
    var gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap || 24) || 24;
    return Math.round(c.getBoundingClientRect().width + gap);
  };
})();
